import { Outlet } from "react-router-dom";
import MainNavbar from "../components/MainNavbar";

const MIN_WIDTH_THRESHOLD = "270px";

function MainLayout()
{
    return (
        <div className="min-vh-100 d-flex flex-column" style={{ minWidth: MIN_WIDTH_THRESHOLD}}>
            <MainNavbar className="sticky-top"/>
            <div className="container-fluid px-2 py-3 p-md-3 d-flex flex-column flex-grow-1">
                <Outlet />
            </div>
        </div>
    );
}

export default MainLayout;